import { useCallback, useEffect } from 'react';

const SCROLL_OPTIONS: ScrollIntoViewOptions = { behavior: 'smooth', block: 'start' };

/**
 * Single entry point for the Utilization page's section navigation.
 * - `scrollToSection(id)` smooth-scrolls to a section, null-safe.
 * - On mount, honors a `#section` anchor present in the URL.
 */
export const useScrollToSection = () => {
  const scrollToSection = useCallback((id: string) => {
    document.getElementById(id)?.scrollIntoView(SCROLL_OPTIONS);
  }, []);

  useEffect(() => {
    const id = window.location.hash.replace(/^#/, '');
    if (id) {
      scrollToSection(id);
    }
  }, [scrollToSection]);

  return { scrollToSection };
};
